import _extends from "@babel/runtime/helpers/extends";
import React, { useState } from "react";
import styled from "styled-components";
import mixpanel from "mixpanel-browser";
import { Alert, Button, Modal, Text } from "~/components-shared";
import { AnimClassEnum, AnimOrderEnum, RoutesEnum } from "~/types/enums";
import { useTranslation } from "react-i18next";
import AuthCompleteForm from "~/forms/AuthCompleteForm";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import authCompleteSchema from "~/forms/AuthCompleteForm/authCompleteSchema";
import api from "~/lib/api";
import { useHistory } from "react-router-dom";
import { handleError } from "~/lib/helpers";
import Markdown from "~/components/Markdown";
const Wrapper = styled.div`
  width: 100%;
`;
const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const CompleteSignUp = _ref => {
  let {
    data,
    ...rest
  } = _ref;
  const {
    t
  } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(undefined);
  const history = useHistory();
  const {
    createdBy,
    company
  } = data;
  const {
    handleSubmit,
    control,
    watch
  } = useForm({
    resolver: yupResolver(authCompleteSchema),
    mode: "onChange",
    defaultValues: {
      password: "",
      repeatPassword: ""
    }
  });
  const onSubmit = handleSubmit(formData => {
    setLoading(true);
    const payload = {
      ...formData,
      memberId: createdBy.id,
      companyId: company.id
    };
    api.completeInvitation(data.id, payload).then(() => {
      setSuccess(true);
    }).catch(e => {
      setError(handleError(e));
    }).finally(() => {
      setLoading(false);
    });
    mixpanel.track(`Complete Sign-up – Submit`, {
      memberId: createdBy.id,
      companyId: company.id
    });
  });
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    className: `${AnimOrderEnum.ONE} ${AnimClassEnum.POP_BOTTOM_FADE}`
  }, rest), /*#__PURE__*/React.createElement(Text, {
    element: "p",
    s: {
      mb: 3
    },
    fontSize: 5,
    lineHeight: 8,
    weight: "semiBold",
    align: "center"
  }, /*#__PURE__*/React.createElement(Markdown, {
    text: t("CompleteSignUp.message", {
      userName: `${createdBy?.firstName} ${createdBy?.lastName}`,
      companyName: company.name
    })
  })), error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(AuthCompleteForm, {
    control: control,
    watch: watch
  }), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    s: {
      mt: 5,
      mb: 4
    },
    maxWidth: "280px",
    type: "submit",
    loading: loading,
    fullWidth: true
  }, t("common.actions.continue")), /*#__PURE__*/React.createElement(Markdown, {
    align: "center",
    display: "block",
    fontSize: 3,
    color: "textSecondary",
    linkColor: "text",
    text: "By creating an account you agree to Joyn's [Privacy Policy](https://www.joyn.one/terms-and-privacy/privacy-policy) and [Terms of Use](https://www.joyn.one/terms-and-privacy/terms-of-use)",
    style: {
      maxWidth: "80%"
    }
  })), /*#__PURE__*/React.createElement(Modal, {
    open: success
  }, /*#__PURE__*/React.createElement(Modal.Body, {
    fullWidth: true,
    maxWidth: "560px"
  }, /*#__PURE__*/React.createElement(Modal.Content, {
    style: {
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement(Text, {
    element: "h2",
    fontSize: 20,
    align: "center"
  }, "\uD83C\uDF89"), /*#__PURE__*/React.createElement(Text, {
    element: "h1",
    fontSize: 10,
    align: "center",
    s: {
      mb: 3
    }
  }, t("CompleteSignUp.wellDone")), /*#__PURE__*/React.createElement(Text, {
    element: "h2",
    fontSize: 5,
    align: "center",
    s: {
      mb: 3
    }
  }, t("CompleteSignUp.description")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    s: {
      mt: 3,
      mb: 6
    },
    onClick: () => history.replace(RoutesEnum.ROOT),
    maxWidth: "280px",
    type: "submit",
    fullWidth: true
  }, t("CompleteSignUp.gotoLoginPage"))))));
};
export default CompleteSignUp;